export const categoryList = [{
    id: 1,
    value: 'laptop',
    label: '💻 Laptops',
  },
  {
    id: 2,
    value: 'pc',
    label: '🖥 PC`s',
  },
];

export const ratingList = [

  {
    id: 1,
    value: '1',
    label: '⭐',
  },
  {
    id: 2,
    value: '2',
    label: '⭐⭐',
  },
  {
    id: 3,
    value: '3',
    label: '⭐⭐⭐',
  },
  {
    id: 4,
    value: '4',
    label: '⭐⭐⭐⭐',
  },
  {
    id: 5,
    value: '5',
    label: '⭐⭐⭐⭐⭐',
  },
];

export const dataList = [{
    id: 1,
    title: 'GAMER ESSENTIAL ESPORTS',
    category: 'pc',
    model: 'gamer',
    gpu: 'NVIDIA 3070',
    rating: 5,
    price: 1319,
    link: 'https://www.amazon.com/dp/B07WQ35XWS?tag=goorgy-20',
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/pc008/cs-450-160_400.png',
    count: 1
  },
  {
    id: 2,
    title: 'GAMER XTREME',
    category: 'pc',
    model: 'gamer',
    gpu: 'NVIDIA 3060 TI',
    rating: 4,
    price: 1735,
    link: 'https://www.amazon.com/dp/B08248WSJ7?tag=goorgy-20',
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/P428X/cs-450-168_220.png',
    count: 1
  },
  {
    id: 3,
    title: 'PC Engine  ULTIMATE',
    category: 'pc',
    model: 'ultimate',
    gpu: 'NVIDIA ',
    rating: 3,
    price: 2935,
    link: 'https://www.amazon.com/dp/B07VFFCQ6L?tag=goorgy-20',
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/cube802/CS-192-401_220.png',
    count: 1
  },
  {
    id: 4,
    title: 'INFINITY 8800 PRO SE',
    category: 'pc',
    model: 'infinity',
    gpu: 'NVIDIA ',
    rating: 1,
    price: 3185,
    link: "https://www.amazon.com/dp/B07VFFCQ6L?tag=goorgy-20",
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/PCO11/cs-193-101_220.png',
    count: 1
  },
  {
    id: 5,
    title: 'GAMER INFINITY 8000',
    category: 'pc',
    model: 'infinity',
    gpu: 'NVIDIA ',
    rating: 5,
    link: 'https://www.amazon.com/dp/B08248WSJ7?tag=goorgy-20',
    prisce: 1455,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/eluna242v/CS-450-153_220.png?v2',
    count: 1
  },
  {
    id: 6,
    title: 'SUMMER SPECIAL I',
    category: 'pc',
    model: 'special',
    gpu: 'NVIDIA ',
    rating: 5,
    link: 'https://www.amazon.com/dp/B07PKXQBHN?tag=goorgy-20',
    price: 1175,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/onyxia3/CS-450-162_220.png',
    count: 1
  },
  {
    id: 7,
    title: 'SUMMER 2022',
    category: 'pc',
    model: 'special',
    gpu: 'NVIDIA ',
    rating: 2,
    price: 2009,
    link: 'https://www.amazon.com/dp/B07VGJDKZ4?tag=goorgy-20',
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/amethystii241v/cs-450-167_220.png',
    count: 1
  },
  {
    id: 8,
    title: 'SUMMER SPECIAL II',
    category: 'pc',
    model: 'special',
    gpu: 'NVIDIA ',
    rating: 1,
    link: 'https://www.amazon.com/dp/B07WHNNT7Z?tag=goorgy-20',
    price: 1085,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/inwin101rgb/cs-415-158_220.png',
    count: 1
  },
  {
    id: 9,
    title: 'Black Mamba',
    category: 'pc',
    model: 'ultimate',
    gpu: 'NVIDIA ',
    rating: 4,
    link: 'https://www.amazon.com/dp/B07NFR9K5Y?tag=goorgy-20',
    price: 4350,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/PCO11RAZER/CS-193-104_220.png',
    count: 1
  },
  {
    id: 10,
    title: 'BATTLEBOX 2022 ULTIMATE',
    category: 'pc',
    model: 'ultimate',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B01M5G2MLO?tag=goorgy-20',
    price: 3095,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/corsair4000dair/cs-429-144_220.png?v1',
    count: 1
  },
  {
    id: 11,
    title: 'ICUE ULTIMATE 300',
    category: 'pc',
    model: 'ultimate',
    gpu: 'NVIDIA ',
    rating: 3,
    link: 'https://www.amazon.com/dp/B07NFR9K5Y?tag=goorgy-20',
    price: 2615,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/corsair4000dair/cs-429-144_220.png?v1',
    count: 1
  },
  {
    id: 12,
    title: 'GAMER MASTER 9500',
    category: 'pc',
    model: 'gamer',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B07TT8N6C6?tag=goorgy-20',
    price: 2869,
    coverSrc: 'https://www.cyberpowerpc.com/images/cs/h510flow/CS-211-224_220.png',
    count: 1
  },
  {
    id: 13,
    title: 'ASUS ROG Strix G713',
    category: 'laptop',
    model: 'gamer',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B07YM938TP?tag=goorgy-20',
    price: 2115,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM7TGP/01_220.png?v3',
    count: 1
  },
  {
    id: 14,
    title: 'TRACER V EDGE PRO I15X 550',
    category: 'laptop',
    model: 'infinity',
    gpu: 'NVIDIA ',
    link: 'https://www.amazon.com/dp/B085B3GFRL?tag=goorgy-20',
    rating: 2,
    price: 1899,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM5TGW/01_220.png?v3',
    count: 1
  },
  {
    id: 15,
    title: 'PC Engine Gaming PRO I17X 550',
    category: 'laptop',
    model: 'gamer',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B085B316LG?tag=goorgy-20',
    price: 1185,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM7TGR/01_220.png?v3',
    count: 1
  },
  {
    id: 16,
    title: 'HYPERPC PLAY 15',
    category: 'laptop',
    model: 'ultimate',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B0843JCV17?tag=goorgy-20',
    price: 1179,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM7NG0R/01_220.png',
    count: 1
  },
  {
    id: 17,
    title: 'HYPERPC PLAY 17',
    category: 'laptop',
    model: 'special',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B086M84ZC9?tag=goorgy-20',
    price: 1479,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM7AG/01_220.png',
    count: 1
  },
  {
    id: 18,
    title: 'TRACER V EDGE I15E 200',
    category: 'laptop',
    model: 'gamer',
    gpu: 'NVIDIA ',
    rating: 2,
    link: 'https://www.amazon.com/dp/B086KJBKDW?tag=goorgy-20',
    price: 805,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/GM5TGO/01_220.png?v4',
    count: 1
  },
  {
    id: 19,
    title: 'TRACER V EDGE I15E 200',
    category: 'laptop',
    model: 'special',
    gpu: 'NVIDIA ',
    link: 'https://www.amazon.com/dp/B07RKSNCT6?tag=goorgy-20',
    graphics: "iris",
    rating: 2,
    price: 1220,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/M15/01_220.png?v2',
    count: 1
  },
  {
    id: 20,
    title: 'PC Engine VI Gaming I15XLC PRO 500',
    category: 'laptop',
    model: 'infinity',
    gpu: 'NVIDIA ',
    link: 'https://www.amazon.com/dp/B07RKSNCT6?tag=goorgy-20',
    rating: 2,
    price: 1220,
    coverSrc: 'https://www.cyberpowerpc.com/images/nb/M15/01_220.png?v2',
    count: 1
  },

];